import React from 'react';
import { FormControlProps } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import shortid from 'shortid';
import FormControlClear from './FormControlClear';
import "./TextInput.css"

export interface TextInputProps extends FormControlProps {
    /** Custom input wrapper class */
    wrapperClassName?: string;
    /** Custom input wrapper styles */
    wrapperStyles?: any;
    name?: string;
}

let uniqueId: string = shortid.generate();

const TextInput: React.FC<TextInputProps> = (props: TextInputProps) => {
    const { wrapperClassName, wrapperStyles } = props;
    const inputProps = (({ wrapperClassName, wrapperStyles, ...p }) => p)(props);
    return (
        <div style={{...wrapperStyles}} className={"d-flex flex-row align-items-center " + wrapperClassName}>
            <Form.Control className={`text-input ${uniqueId}`} {...inputProps} />
            {(!props.readOnly && !props.disabled) &&
                <FormControlClear field={`.${uniqueId}`} />
            }
        </div>
    );
}

TextInput.defaultProps = {
    wrapperClassName: "",
    wrapperStyles: {},
}

export default TextInput;